import _regeneratorRuntime from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/scazz/Code/malaysia.ffde/node_modules/@babel/runtime/helpers/esm/inherits";
import fs from 'fs';
import { BaseSource } from './basesource';
function closeAsync(fd) {
  return new Promise(function (resolve, reject) {
    fs.close(fd, function (err) {
      if (err) {
        reject(err);
      } else {
        resolve();
      }
    });
  });
}
function openAsync(path, flags) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    fs.open(path, flags, mode, function (err, fd) {
      if (err) {
        reject(err);
      } else {
        resolve(fd);
      }
    });
  });
}
function readAsync() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return new Promise(function (resolve, reject) {
    fs.read.apply(fs, args.concat([function (err, bytesRead, buffer) {
      if (err) {
        reject(err);
      } else {
        resolve({
          bytesRead: bytesRead,
          buffer: buffer
        });
      }
    }]));
  });
}
var FileSource = /*#__PURE__*/function (_BaseSource) {
  _inherits(FileSource, _BaseSource);
  function FileSource(path) {
    var _this;
    _classCallCheck(this, FileSource);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileSource).call(this));
    _this.path = path;
    _this.openRequest = openAsync(path, 'r');
    return _this;
  }
  _createClass(FileSource, [{
    key: "fetchSlice",
    value: function () {
      var _fetchSlice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(slice) {
        var fd, _yield$readAsync, buffer;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.openRequest;
              case 2:
                fd = _context.sent;
                _context.next = 5;
                return readAsync(fd, Buffer.alloc(slice.length), 0, slice.length, slice.offset);
              case 5:
                _yield$readAsync = _context.sent;
                buffer = _yield$readAsync.buffer;
                return _context.abrupt("return", buffer.buffer);
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function fetchSlice(_x) {
        return _fetchSlice.apply(this, arguments);
      }
      return fetchSlice;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var fd;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.openRequest;
              case 2:
                fd = _context2.sent;
                _context2.next = 5;
                return closeAsync(fd);
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function close() {
        return _close.apply(this, arguments);
      }
      return close;
    }()
  }]);
  return FileSource;
}(BaseSource);
export function makeFileSource(path) {
  return new FileSource(path);
}